import { getWsInstance } from "../../../api/WsManagement";
import { Vec3 } from "../../../models/SyntheticMap";
import { BaseActor } from "./BaseActor";
import * as THREE from "three";

export class ActorPathVisualizer {
  private line: THREE.Line;
  private points: THREE.Vector3[] = [];

  constructor(private actor: BaseActor) {
    const geometry = new THREE.BufferGeometry();
    const material = new THREE.LineBasicMaterial({ color: 0x0000ff, linewidth: 2 });
    this.line = new THREE.Line(geometry, material);
    const uiService = getWsInstance().uiService;
    uiService.scene.add(this.line);
    this.actor.on('pathUpdate', (path: Vec3[]) => {
      console.log(path);
      let pathWithCurrentLocation: Vec3[] = [this.actor.obj.position, ...path];
      this.setPath(pathWithCurrentLocation);
    });
  }

  public setPath(path: Vec3[]) {
    if (path.length < 2) {
      this.line.visible = false;
      return;
    }
    // Convert Vec3 to THREE.Vector3    
    this.points = path.map(p => {
      const z = Math.max(p.z, 0.01); // Ensure z is not zero
      return new THREE.Vector3(p.x, p.y, z);
    });
    this.line.geometry.setFromPoints(this.points);
    this.line.visible = true;
  }
}